// Pure helpers for the typed time fields (ds-form-time-input and the time
// part of ds-form-date-input). The form value is always "HH:MM" (24-hour);
// what the person types and sees follows their hour cycle ("h12" or "h24").

const pad = (n) => String(n).padStart(2, "0");

// "17:30", "1730", "930", "9", "5:30 pm", "5:30pm", "5.30pm", "5pm", "5 p",
// "12 am" -> "HH:MM", or null when it is not a real time of day. A time with
// no am/pm is read as 24-hour in both cycles.
export const parseTime = (text) => {
  const m = /^(\d{1,2})(?:[:.]?(\d{2}))?\s*([ap])?m?\.?$/i.exec(String(text || "").trim());
  if (!m) return null;
  let hours = +m[1];
  const minutes = m[2] === undefined ? 0 : +m[2];
  const meridiem = m[3] ? m[3].toLowerCase() : null;
  if (minutes > 59) return null;
  if (meridiem) {
    if (hours < 1 || hours > 12) return null;
    hours = (hours % 12) + (meridiem === "p" ? 12 : 0);
  } else if (hours > 23) {
    return null;
  }
  return `${pad(hours)}:${pad(minutes)}`;
};

// "17:30" -> "5:30 pm" (h12) or "17:30" (h24). "" for anything unparseable.
export const formatTime = (hhmm, cycle) => {
  const m = /^(\d{1,2}):(\d{2})/.exec(hhmm || "");
  if (!m) return "";
  const hours = +m[1];
  if (cycle === "h12") {
    return `${hours % 12 === 0 ? 12 : hours % 12}:${m[2]} ${hours < 12 ? "am" : "pm"}`;
  }
  return `${pad(hours)}:${m[2]}`;
};

export const timeExample = (cycle) => (cycle === "h12" ? "5:30 pm" : "17:30");

export const timeProblem = (cycle) => `Enter a time like ${timeExample(cycle)}`;
